import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';

export interface QuestionState {
    index: number;
    id: number;
    question: string;
    audio_source: string;
    is_interactive: boolean;
    interactive_type?: "pie_chart" | "bar_chart" | "line_chart" | "sequential" | "clickable" | string;
    min?: number;
    max?: number;
    step?: number;
    interactive_detail?: any[];
    type: string;
    categoryTitle: string;
    choices: any;
    selectedOption: string;
    answerText: string[];
    duration: number;
}

const initialState: QuestionState = {
    index: 0,
    id: 0,
    question: "",
    audio_source: "",
    is_interactive: false,
    interactive_type: "",
    min: 0,
    max: 0,
    step: 1,
    interactive_detail: [],
    type: "",
    categoryTitle: "",
    choices: [],
    selectedOption: "",
    answerText: [],
    duration: 0,
};

function convertAudioSourceToProd(audio_source: string) {
    if (process.env.NODE_ENV === "development") {
        return audio_source?.replace(
            "devbrofesional.sgp1.cdn.digitaloceanspaces.com",
            "brofesional.sgp1.cdn.digitaloceanspaces.com"
        );
    }
    return audio_source;
}

export const questionSlice = createSlice({
    name: 'question',
    initialState,
    reducers: {
        setQuestion: (state, action: PayloadAction<QuestionState>) => {
            state.index = action.payload.index;
            state.id = action.payload.id;
            state.question = action.payload.question;
            state.audio_source = convertAudioSourceToProd(action.payload.audio_source);
            state.is_interactive = action.payload.is_interactive;
            state.interactive_type = action.payload.interactive_type;
            state.min = action.payload.min;
            state.max = action.payload.max;
            state.step = action.payload.step;
            state.interactive_detail = action.payload.interactive_detail;
            state.type = action.payload.type;
            state.categoryTitle = action.payload.categoryTitle;
            state.choices = action.payload.choices;
            state.selectedOption = action.payload.selectedOption;
            state.answerText = action.payload.answerText;
            state.duration = action.payload.duration;
        },
    }
});

export const { setQuestion } = questionSlice.actions;

export default questionSlice.reducer;